// extracted by mini-css-extract-plugin
module.exports = {"sectionWrapper":"style_sectionWrapper__kDKPo","gradientOverlay":"style_gradientOverlay__bFeBK","innerGradient":"style_innerGradient__SHm4a"};